import { Principle } from '../../app/shared/interfaces/principle.interface'

export const principles: Principle[] = [
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P5',
    label: 'Croissance inclusive, développement durable et bien-être',
    code: '1_1',
    description: null,
    icon: 'p5',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P5'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P6',
    label: "Valeurs centrées sur l'humain et équité",
    code: '1_2',
    description: null,
    icon: 'p6',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P6'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P7',
    label: 'Transparence et explicabilité',
    code: '1_3',
    description: null,
    icon: 'p7',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P7'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P8',
    label: 'Robustesse, sûreté et sécurité',
    code: '1_4',
    description: null,
    icon: 'p8',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P8'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P9',
    label: 'Responsabilité',
    code: '1_5',
    description: null,
    icon: 'p9',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P9'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P10',
    label: 'Investir dans la recherche et le développement en matière d’IA',
    code: '2_1',
    description: null,
    icon: 'p10',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P10'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P11',
    label: 'Favoriser l’instauration d’un écosystème numérique pour l’IA',
    code: '2_2',
    description: null,
    icon: 'p11',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P11'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P12',
    label: 'Façonner un cadre d’action favorable à l’IA',
    code: '2_3',
    description: null,
    icon: 'p12',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P12'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P13',
    label:
      'Renforcer les capacités humaines et préparer la transformation du marché du travail',
    code: '2_4',
    description: null,
    icon: 'p13',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P13'
      }
    },
    subitems: []
  },
  {
    uri: 'http://ai.oecd.org/taxonomy/principles#P14',
    label:
      'Favoriser la coopération internationale au service d’une IA digne de confiance',
    code: '2_5',
    description: null,
    icon: 'p14',
    link: {
      view: 'AIPrincipleDashboard',
      params: {
        uri: 'http://ai.oecd.org/taxonomy/principles#P14'
      }
    },
    subitems: []
  }
]
